import type { ProductWithAdditionalCharges } from '../types';

const getAreAdditionalChargesApplicableForProduct = (
    product?: ProductWithAdditionalCharges
) => {
    if (!product) {
        return false;
    }
    const { variants } = product;
    return variants && variants.length
        ? variants.some(variant => variant.additionalCharges.length)
        : product.additionalCharges.length > 0;
};

export default getAreAdditionalChargesApplicableForProduct;
